module.exports = __webpack_public_path__ + "static/media/motorcycle.659a143b.svg";